export default __webpack_public_path__ + "static/media/card-junior-m.0965ab06.jpg";